import { useParams, Link } from "react-router-dom";
import { Home } from "lucide-react";
import { Card } from "@/components/ui/card";
import ProtocolCard from "@/components/protocol/ProtocolCard";
import { useService } from "@/contexts/ServiceContext";

export default function CategoryPage({ protocols, favorites, onToggleFavorite }) {
  const { categoryId } = useParams();
  const { activeService, SERVICES } = useService();
  const categoryProtocols = protocols.filter(p => p.category === categoryId);
  const categoryName = categoryId.charAt(0).toUpperCase() + categoryId.slice(1).replace(/-/g, ' ');

  const serviceLabel = activeService === "sfa_emr" ? "SFA/EMR"
    : activeService === "wes" ? "PCP-PS"
    : activeService === "air_adult" ? "Air Ambulance – Adult"
    : activeService === "air_pediatric" ? "Air Ambulance – Peds"
    : "Ground";

  return (
    <div className="space-y-6">
      <div>
        <Link 
          to="/"
          className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors mb-2"
          data-testid="category-return-dashboard"
        >
          <Home className="w-4 h-4" />
          Return to {serviceLabel} Dashboard
        </Link>
        <h1 className="font-heading text-2xl font-bold">{categoryName}</h1>
        <p className="text-muted-foreground">{categoryProtocols.length} protocols</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {categoryProtocols.map(protocol => (
          <ProtocolCard 
            key={protocol.id} 
            protocol={protocol}
            isFavorite={favorites.some(f => f.protocol_id === protocol.id)}
            onToggleFavorite={onToggleFavorite}
          />
        ))}
      </div>
      
      {categoryProtocols.length === 0 && (
        <Card className="p-8 text-center">
          <p className="text-muted-foreground">No protocols in this category yet.</p>
        </Card>
      )}
    </div>
  );
}
